<template>
  <div>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <router-view name="popup" />
  </div>
</template>

<script>
  import store from './store'

  store.dispatch('user/loadUser')

  export default {
    name: 'App',
    store
  }
</script>

<style>
  html, body {
    padding: 0;
    margin: 0;
    border: 0;
    background-color: #c8c4c1 !important;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #414141;
  }

  .content-wrapper {
    max-width: 1180px;
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }

  .translucent-border {
    border: solid 5px rgba(255, 255, 255, 0.5) !important;
    -webkit-background-clip: padding-box !important;
    background-clip: padding-box !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue